// extracted by mini-css-extract-plugin
export var container = "styles-module__container___ZELCE";
export var header = "styles-module__header___odk6Z";
export var appSectionContainer = "styles-module__appSectionContainer___mSoi_";
export var appRatingContainer = "styles-module__appRatingContainer___YzPr8";
export var storeBadgeContainer = "styles-module__storeBadgeContainer___Qf9kT";
export var downloadCodeContainer = "styles-module__downloadCodeContainer___bz3Ev";
export var codeImage = "styles-module__codeImage___kIt1V";
export var editorsChoiceImage = "styles-module__editorsChoiceImage___X2F0j";
export var testimonialSectionContainer = "styles-module__testimonialSectionContainer___WOeI8";
export var bgImage = "styles-module__bgImage___k21vh";
export var dialogBoxContainer = "styles-module__dialogBoxContainer___lCMch";
export var description = "styles-module__description___f8zQB";
export var ratingContainer = "styles-module__ratingContainer___PJrWx";
export var reviewerContainer = "styles-module__reviewerContainer___iMTf_";
export var reviewer = "styles-module__reviewer___ZU4UU";
export var ratingValue = "styles-module__ratingValue___rM2gG";